import { FC } from 'react';
import { isMobile } from '../../../helpers/devices';
import { FullScreenPortal } from './full-screen-portal';
import { TooltipPortal } from './tooltip-portal';
import { PortalProps } from './types';

export const Portal: FC<PortalProps> = (props) => {
  const { triggerRef, fullScreen } = props;

  const isFullScreen = fullScreen || isMobile();

  if (!triggerRef) return null;
  if (isFullScreen) return <FullScreenPortal {...props} />;
  return <TooltipPortal {...props} />;
};
